import React from 'react'
import { Box, CircularProgress } from '@mui/material'
import { useLineStatusQuery } from '@/features/internal/patient-messaging/hooks/queries/useLineStatusQuery'
import LineLinkSection from './LineLinkSection'
import LineChat from './LineChat'

interface LineTabProps {
  patientId: string
}

const LineTab: React.FC<LineTabProps> = ({ patientId }) => {
  const { data: lineStatus, isLoading } = useLineStatusQuery(patientId)

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CircularProgress size={32} />
      </Box>
    )
  }

  // 薬局LINE未設定 or 患者未連携 → LineLinkSection
  if (!lineStatus?.conversation_thread_id) {
    return (
      <Box sx={{ height: '100%' }}>
        <LineLinkSection
          patientId={patientId}
          isPharmacyConfigured={lineStatus?.is_pharmacy_configured ?? false}
        />
      </Box>
    )
  }

  // 連携済み → チャット
  return (
    <Box sx={{ height: 'calc(100vh - 250px)' }}>
      <LineChat threadId={lineStatus.conversation_thread_id} />
    </Box>
  )
}

export default LineTab
